<template>
  <zen-one 
    :showuserinfo="false" 
    :crumbs="crumbs"
    title="Sistem Hasil Bersepadu Kedah (iHasil)"
  >

    <z-page title="Konfigurasi Proses Penyesuaian">

        <div class="message-box">
          <w-transition-fade>
            <w-alert
              class="my0 text-light"
              v-if="form.submitted"
              success
              no-border>
              The form is valid, ready to send it!
            </w-alert>

            <w-alert
              class="my0 text-light"
              v-else-if="form.valid === false"
              error
              no-border>
              Terdapat {{ form.errorsCount }} ralat di dalam borang ini.
            </w-alert>
          </w-transition-fade>
        </div>

        <w-form
          class=""
          v-model="form.valid"
          v-model:errors-count="form.errorsCount"
          @validate="onValidate"
          @success="onSuccess">
          <w-card bg-color="" class="">
            <w-flex class="mt3">
                <div class="xs6 mr5">
                  <w-input
                    type="file"
                    placeholder="Sila Muatnaik Fail Penyata Bank" 
                    required
                    v-model="files"
                    label="Konfigurasi" />
                </div>
                <div class="xs6">
                    <w-button class="my1" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent">
                        <w-icon dark tile class="mr2">fal fa-paper-plane</w-icon> Simpan
                    </w-button>
                </div>

            </w-flex>
          </w-card>
          <br>

          <w-card bg-color="" class="">
            <z-table title="Konfigurasi Proses Penyesuaian" :headers="table.headers" :items="table.items" :meta="table.meta" class="">
            </z-table>
          </w-card>

        </w-form>

        <w-notification
          v-model="form.sent"
          success
          transition="bounce"
          absolute
          plain
          round
          bottom>
          Borang telah berjaya dihantar
        </w-notification>

    </z-page>

  </zen-one>
</template>

<script>

// import Vue3ChartJs from '@j-t-mcc/vue3-chartjs'
import ZResource from '@/Modules/z-resource-service'

export default {
  extends: ZResource,
  components: {
    // Vue3ChartJs
  },
  props: {
      items: [Array, Object],
  },
  data() {
      return {
        resourceurl: this.service_penyata+'penyata',
        form: {
          valid: null,
          submitted: false,
          sent: false,
          errorsCount: 0
        },
        validators: {
          required: value => !!value || 'This field is required',
          consent: value => !!value || 'You must agree'
        },
        crumbs: [
              { label: 'iHasil', route: '/' },
              { label: 'Penyata Penyesuaian', route: '/penyesuaian' },
              { label: 'Konfigurasi', route: '/penyesuaian/konfigurasi' },
        ],
        showCard: false,
        files:[],
      }},
  methods: {
    onSuccess () {
      setTimeout(() => (this.form.sent = true), 2000)
      // this.$inertia.visit(window.route('penyesuaian.index'));

    },
    onValidate () {
      this.form.sent = false
      this.form.submitted = this.form.errorsCount === 0
    }
  }
}

</script>